module.exports = __webpack_public_path__ + "img/DO.4ba64fb6.svg";